<template>
  <div class="page">
    <div class="mask-layer" v-if="isUploadingFlag">
      <div class="tip-box">
        <div>
          <div class="loading-li"></div>
          <div class="loading-li"></div>
          <div class="loading-li"></div>
          <div class="loading-li"></div>
          <div class="loading-li"></div>
          <div class="loading-li"></div>
          <div class="loading-li"></div>
          <div class="loading-li"></div>
          <!--<div class="loading-li"></div>-->
          <!--<div class="loading-li"></div>-->
        </div>
        <p>加密上传中</p>
      </div>
    </div>
    <div class="nav">
      <div class="nav-title">
        <p>车家</p>
        <p>资料上传助手</p>
      </div>
      <p class="cus_info" v-html="mobile+' '+ name"></p>
      <div class="goBack" @click="goBack">
        <img src="../../assets/image/CustomersInfo/quit.png"/>
      </div>
    </div>
    <div class="header">
      <img src="../../assets/image/CustomersInfo/collect_banner.png"/>
      <div class="page-title">
        <p>您好</p>
        <p>请根据业务需求提交资料</p>
        <p>具体情况可咨询您的客户经理</p>
      </div>
    </div>
    <div class="content">
      <div class="upload_part">
        <div class="part-title">可提交资料</div>
        <div class="upload-notice">
          <p>- 本人身份证正反面、驾驶证正反面、银行卡正面</p>
          <p>- 其他资料</p>
        </div>
        <div class="upload-content">
          <van-uploader ref="vantupload" @delete="del" :after-read="afterRead" :before-read="beforeRead" v-model="fileList"
                        preview-options.closeable="true" multiple="true" max-count="20" closeable="true"/>
        </div>
        <button @click="upload" :disabled="isUploadingFlag">提交上传</button>
      </div>
      <div class="show_upload_part">
        <div class="part-title">
          <p>已上传资料</p>
          <p>已上传资料在15天后自动删除</p>
        </div>
        <van-loading size="24px" v-if="images.length == 0 && !isAlreadyUpload">加载中...</van-loading>
        <div class="no-search" v-if="isAlreadyUpload">还未上传影像照片</div>
        <div class="show_content">
          <div v-for="item,index in images" :data-code="index" :key="index"  @click="lookimg(index)">
            <img :src="item" v-if="item!=null&&item!=''"/>
          </div>
          <div v-for="item,index in (4-images.length%4)" v-if="images.length%4 != 0"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import common from "../../utils/common";
  import VueCookies from 'vue-cookies';
  import {Dialog, ImagePreview, Toast } from "vant";
  export default {
    name: "Cus_Collect",
    data() {
      return {
        name: '',
        mobile: null,
        isUploadingFlag: false,
        isWeChatFlag: false,
        isAlreadyUpload: false,
        images: [],
        fileList: [],
        fileArr: []
      }
    },
    mounted() {
      this.$nextTick(()=> {
        const that = this
        window.scrollTo(0, 0)
        that.mobile = sessionStorage.getItem("mobile")
        if (!VueCookies.get("tokenflag") || !sessionStorage.getItem("access_token")) {
          common.redirect(this, "");
          return;
        }
        that.isWeChatFlag = common.isWeChat()
        that.getUserImage()
        that.getName()
      })
    },

    methods: {
      getName() {
        const that = this
        that.$axios({
          method: 'GET',
          url: '/marketing/info',
          headers: {
            Authorization: "Bearer " + sessionStorage.getItem("access_token")
          },
        }).then(function (res) {
          // res.data.data.customerName = null
          // res.data.data.customerName= '古丽娜一扎·热玛哈'
          if(!common.isEmpty(res.data.data.customerName)) {
            let name = res.data.data.customerName
            if(name.length > 3) {
              name = name.slice(0,3).concat('...')
            }
            that.name = name
          }
        })
      },
      getUserImage() {
        const that = this
        that.$axios({
          method: 'GET',
          url: '/marketing/images?mobile=' + that.mobile,
          headers: {
            Authorization: "Bearer " + sessionStorage.getItem("access_token")
          },
        }).then(function (res) {
          // res.data.data = null
          if(!common.isEmpty(res.data.data) && res.data.data.length > 0) {
            res.data.data = res.data.data.sort(that.sortBy('uploadTime'))
            that.images = res.data.data.map(item =>{
              return item.imageBase64 = 'data:image/png;base64,' + item.imageBase64
            })
            return
          }
          that.isAlreadyUpload = true
        }).catch(function (err) {
          // common.tipToast("已上传影像照片显示错误！！！")
          console.log("已上传影像照片显示错误！！！")
        })
      },
      lookimg(index) {
        ImagePreview({
          images: this.images,
          startPosition: index,
          closeable: true,
          closeOnPopstate: true
        })

      },
      beforeRead(file) {
        //上传之前校验
        if (!common.isEmpty(file.length)) {
          for (let fileItem of file) {
            if (
              fileItem.type !== "image/jpeg" &&
              fileItem.type !== "image/png" &&
              fileItem.type !== "image/jpg"
            ) {
              common.tipToast("只允许上传jpg/png格式的图片！");
              return false;
            }
          }
        } else {
          if (
            file.type !== "image/jpeg" &&
            file.type !== "image/png" &&
            file.type !== "image/jpg"
          ) {
            common.tipToast("只允许上传jpg/png格式的图片！");
            return false;
          }
        }
        return true;
      },

      async afterRead(file) {
        //文件读取完成后的回调函数
         Toast.loading({
           message: '加载中...',
           forbidClick: true
         });
         let [totalSize, imgSize, imgSrc] = [0, 0, null];
         if (!common.isEmpty(file.length)) {
           for (let key in file) {
             await this.compress(file[key], parseInt(key) + 1);
           }
         } else {
           await this.compress(file, 1);
         }
         Toast.clear();
      },
      // 压缩照片 压缩后上传文件超过1M会上传失败
      compress(file, index) {
        let reg = new RegExp("-", "g"); //g代表全部
        const that = this;
        lrz(file.file, {quality: 0.4}).then(function (rst) {
          if (rst.fileLen > 1000000) {
            that.fileList = that.fileList.filter(item => item.file.lastModified != file.file.lastModified)
            common.tipToast("照片过大，请重新选择");
            return;
          }
          rst.file.filename = common.trimAll(rst.origin.name.replace(reg, ""));
          let imagename = rst.file.filename;
          if (rst.file.filename == "image.jpg") {
            imagename = that.mobile + rst.fileLen + ".jpg";
          }
          if (rst.file.filename == "image.png") {
            imagename = that.mobile + rst.fileLen + ".png";
          }
          let imageDTOS = {}
          imageDTOS.imageBase64 = rst.base64
          imageDTOS.fileName = imagename
          that.fileArr.push(imageDTOS);
        });
      },
      // 删除按钮
      del(file) {
        if (!common.isEmpty(this.fileArr) && this.fileArr.length > 0) {
          let arr = this.fileArr.filter(item => {
            return item.fileName != file.file.name;
          });
          this.fileArr = arr;
        }
      },

      goBack: _.throttle(function(){
        common.redirect(this, '')
      }),

      upload: _.throttle(function(){
        const that = this
        if(common.isEmpty(that.fileArr)) {
          common.tipToast('请选择上传照片')
          return
        }
        let obj = {}
        obj.mobile = that.mobile
        obj.imageDTOS = that.fileArr
        that.isUploadingFlag = true
        that.$axios({
          method: 'put',
          url: '/marketing/images',
          data: obj,
          headers: {
            'Content-Type': 'application/json',
             Authorization: "Bearer " + sessionStorage.getItem("access_token")
          },
        }).then(function (res) {
          that.fileArr = []
          that.fileList = []
          common.redirect(that, 'cus_success')
        }).catch(function (err) {
          that.isUploadingFlag = false
          common.tipToast(err.data.msg)
        })
      }),

      sortBy(key) {
        return (obj1, obj2) => {
          let value1 = obj1[key]
          let value2 = obj2[key]
          if (value1 < value2) {
            return 1;
          } else if (value1 > value2) {
            return -1;
          } else {
            return 0
          }
        }
      }
    }
  }
</script>

<style scoped lang="less">
  .page {
    position: relative;
    margin: 0 auto;
    width: 7.5rem;
    min-height: 100vh;
    background: #f7f7f7;
    p, button {
      margin: 0;
      padding: 0;
    }
    .mask-layer {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background-color: rgba(255,255,255,0);
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
      justify-content: center;
      /*box-shadow: 0.02rem 0.02rem 0.3rem 0 rgba(211,211,211,1);*/
      z-index: 5;

      .tip-box {
        width: 2.4rem;
        max-width: 70%;
        min-height: 2.4rem;
        padding: 0.16rem;
        display: flex;
        flex-flow: column nowrap;
        align-items: center;
        justify-content: center;
        background-color: rgba(50,50,51,.88);
        border-radius: 0.08rem;
      }

      .loading-li{
        width: 0.08rem;
        height: 0.42rem;
        margin-right:0.05rem;
        background-color: #fff;
        -webkit-animation: animate 1s infinite;
        animation: animate 1s infinite;
        float: left;
      }

      .loading-li:last-child {
        margin-right: 0px;
      }

      .loading-li:nth-child(10){
        -webkit-animation-delay: 0.9s;
        animation-delay: 0.9s;
      }
      .loading-li:nth-child(9){
        -webkit-animation-delay: 0.8s;
        animation-delay: 0.8s;
      }
      .loading-li:nth-child(8){
        -webkit-animation-delay: 0.7s;
        animation-delay: 0.7s;
      }
      .loading-li:nth-child(7){
        -webkit-animation-delay: 0.6s;
        animation-delay: 0.6s;
      }
      .loading-li:nth-child(6){
        -webkit-animation-delay: 0.5s;
        animation-delay: 0.5s;
      }
      .loading-li:nth-child(5){
        -webkit-animation-delay: 0.4s;
        animation-delay: 0.4s;
      }
      .loading-li:nth-child(4){
        -webkit-animation-delay: 0.3s;
        animation-delay: 0.3s;
      }
      .loading-li:nth-child(3){
        -webkit-animation-delay: 0.2s;
        animation-delay: 0.2s;
      }
      .loading-li:nth-child(2){
        -webkit-animation-delay: 0.1s;
        animation-delay: 0.1s;
      }
      @-webkit-keyframes animate {

        50% {
          -ms-transform: scaleY(0);
          -webkit-transform: scaleY(0);
          transform: scaleY(0);

        }
      }
      @keyframes animate {
        50% {
          -ms-transform: scaleY(0);
          -webkit-transform: scaleY(0);
          transform: scaleY(0);
        }
      }
      p {
        margin-top: 0.24rem;
        font-size: 0.24rem;
        color: #fff;
      }
    }
    .nav {
      position: relative;
      width: 100%;
      height: 0.88rem;
      background: #fff;
      .nav-title {
        position: absolute;
        left: 0.223rem;
        top: 0;
        height: 0.88rem;
        display: flex;
        flex-flow: column nowrap;
        /*align-items: center;*/
        justify-content: center;
        p{
          width: 100%;
          font-size: 0.30rem;
          font-weight: 600;
          color: #222222;
          line-height: 0.325rem;
          text-align: left;
        }
        p:last-child {
          font-size: 0.20rem;
          color: #101010;
          line-height: 0.3rem;
          white-space: nowrap;
        }
      }
      .goBack {
        position: absolute;
        top: 0;
        right: 0.34rem;
        width: 0.84rem;
        height: 0.88rem;
        display: flex;
        align-items: center;
        /*justify-content: center;*/
        img {
          width: 0.84rem;
          height: 0.37rem;
        }
      }

      .cus_info {
        max-width: 4.8rem;
        margin: 0 auto;
        font-size: 0.32rem;
        font-weight: 700;
        color: #000000;
        text-align: center;
        line-height: 0.88rem;
        white-space: nowrap;
      }
    }
    .header {
      position: relative;
      width: 100%;
      font-size: 0;
      img {
        width: 7.5rem;
        height: 3.72rem;
      }
      .page-title {
        position: absolute;
        top: 0.48rem;
        left: 0;
        z-index: 2;
        p:first-child {
          padding-left: 0.44rem;
          font-size: 0.32rem;
          color: #FFFFFF;
          line-height: 0.32rem;
        }
        p:nth-child(2){
          margin-top: 0.32rem;
          width: 7.5rem;
          font-size: 0.38rem;
          font-weight: 600;
          color: #FFFFFF;
          text-align: center;
          line-height: 0.58rem;
        }
        p:last-child {
          margin-top: 0.03rem;
          width: 7.5rem;
          font-size: 0.24rem;
          color: #FFFFFF;
          text-align: center;
          line-height: 0.3rem;
        }
      }
    }

    .content {
      padding-bottom: 0.36rem;
      width: 100%;
      background: #f7f7f7;
      .upload_part {
        transform: translateY(-1.49rem);
        padding: 0.4rem 0.4rem 0.55rem 0.4rem;
        margin: 0 auto;
        width: 7rem;
        border-radius: 0.24rem;
        background-color: #fff;
        .part-title {
          margin: 0 auto 0.10rem auto;;
          font-weight: 600;
          font-size: 0.32rem;
          line-height: 0.45rem;
          color: #222222;
        }
        .upload-notice {
          p {
            font-size: 0.26rem;
            color: #808080;
            line-height: 0.46rem;
          }
        }
        .upload-content {
          margin: 0.49rem 0 0.49rem 0;
          width: 6.4rem;
        }
        button {
          width: 6.2rem;
          height: 0.9rem;
          font-size: 0.3rem;
          font-weight: 600;
          color: #FFFFFF;
          text-align: center;
          border-width: 0;
          outline: none;
          background: #3289FF;
          border-radius: 0.08rem;
        }
        /deep/ .van-uploader {
          margin-left: -0.1rem;
          width: 100%;
          display: block;
        }

        /deep/ .van-uploader__upload {
          margin: 0 0.1rem;
          font-size: 0;
          background: url("../../assets/image/CustomersInfo/upload_btn.png");
          width: 1.4rem;
          height: 1.4rem;
          background-size: 100%;
          border-radius: 0.08rem;
          overflow: hidden;
        }

        /deep/ .van-uploader__upload-icon {
          display: none;
        }

        /deep/ .van-uploader__wrapper {
          display: flex;
        }

        /deep/ .van-uploader__preview {
          margin: 0 0.1rem  0.1rem 0.1rem;
          border-radius: 0.08rem;
          overflow: hidden;
        }

        /deep/ .van-uploader__preview-image {
          width: 1.4rem;
          height: 1.4rem;
        }

      }
      .show_upload_part {
        padding: 0.4rem 0.4rem 0.45rem 0.4rem;
        margin: -1.28rem auto 0 auto;
        width: 7rem;
        border-radius: 0.24rem;
        background-color: #fff;
        .part-title {
          display: flex;
          flex-flow: row nowrap;
          justify-content: space-between;;
          margin: 0 auto 0.06rem auto;
          width: 6.2rem;
          font-weight: 600;
          font-size: 0.32rem;
          line-height: 0.45rem;
          color: #222222;
          p:last-child {
            font-weight: normal;
            font-size: 0.22rem;
            color: #B2B2B2;
            /*text-align: right;*/
          }
        }
        .no-search {
          font-weight: normal;
          font-size: 0.32rem;
          color: #3289FF;
        }
        .show_content {
          display: flex;
          flex-flow: row wrap;
          align-items: center;
          justify-content: space-between;
          div {
            margin-top: 0.20rem;
            width: 1.4rem;
            height: 1.4rem;
            border-radius: 0.08rem;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/CustomersInfo/Cus_Collect.vue